module.exports = __webpack_public_path__ + "img/logo.39bc0254.svg";